/** @jsxImportSource theme-ui */
import FeatureFlags from '@/containers/featureFlags/FeatureFlags';

const FeatureFlagsPage = () => <FeatureFlags />;

export default FeatureFlagsPage;
